module.exports = __webpack_public_path__ + "static/media/Entradas.fb4bb564.jpg";